import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistNamesOnly = () => {
  return axios.get(URL_PREFIX + '/artist-names/')
}

export const getAllArtistNames = (page=1, page_size=10000, CancelToken=null) => {
    const params = {
    page: page,
    page_size: page_size
  }
  return axios.get(URL_PREFIX + '/artist-names-user/', {
    params: params,
    cancelToken: CancelToken?.token
  })
}

export const getArtistNames = (id) => {
  return axios.get(URL_PREFIX + '/artist-names/' + id + '/')
}

export const putArtistNames = (id, param) => {
  return axios.put(URL_PREFIX + '/artist-names/' + id + '/', {
    id,
    ...param
  })
}
